/**
 * The factory's one service worker (`public/sw.js`): Inbox pushes (T-37) and, in a production build,
 * the app itself kept on this device (T-68), so an opened app draws without waiting for the network.
 * A new deploy is fetched behind it, and the update banner offers the reload as before.
 *
 * `?shell=1` turns the app cache on. The dev servers leave it off (Vite serves the app as it changes),
 * so there the worker is only registered when someone turns on pushes.
 */
// Optional chaining: Jest has no import.meta.env.
const isProductionBuild = Boolean(import.meta.env?.PROD);
export const SW_URL = isProductionBuild ? '/sw.js?shell=1' : '/sw.js';

/** Production only, once from index.tsx. Failing to register changes nothing: the app loads as before. */
export function registerAppServiceWorker(): void {
  if (!isProductionBuild || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  const register = () => {
    navigator.serviceWorker.register(SW_URL).catch((error: unknown) => {
      console.warn('[sw] registration failed', error);
    });
  };
  // After the page has loaded, so it doesn't compete with the app's own first requests.
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
